module.exports = __webpack_public_path__ + "files/435af4df89472af78d9816ce37fb537c.png";